import { GeneratedFile } from '@Models';

// `![title](file:name.png)` — the agent's placement marker (D15). Mirrors
// `email_templates._FILE_MARKER_RE`: the alt tolerates one level of nested
// brackets and the destination the angle, quoted-title and padded forms
// remark also renders as an image.
export const FILE_MARKER_RE = /!\[(?:[^[\]]|\[[^\]]*\])*\]\(\s*<?\s*file:([^)>\s]+)\s*(?:"[^"]*"|'[^']*')?\s*>?\s*\)/g;

// Markers inside code never become images, so they are not placements either.
const stripCode = (content: string): string => content.replace(/```[\s\S]*?```/g, '').replace(/`[^`\n]*`/g, '');

const decode = (name: string): string => {
  try {
    return decodeURIComponent(name);
  } catch {
    return name;
  }
};

export const extractFileMarkers = (content: string): string[] =>
  Array.from(stripCode(content).matchAll(FILE_MARKER_RE), (match) => decode(match[1]));

export const resolveFileMarker = (
  src: string | undefined,
  files: GeneratedFile[] | undefined,
): GeneratedFile | undefined => {
  if (!src?.startsWith('file:') || !files?.length) return undefined;
  const name = decode(src.slice('file:'.length));
  return files.find((file) => file.file_name === name && (file.file_type ?? '').startsWith('image/'));
};
